import { render, staticRenderFns } from "./documentFlowSettings.vue?vue&type=template&id=70e88b4c&scoped=true&"
import script from "./documentFlowSettings.vue?vue&type=script&lang=js&"
export * from "./documentFlowSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e88b4c",
  null
  
)

export default component.exports